import React from 'react'
import PropTypes from 'prop-types'
import {Stack, Text, Box, useStyleConfig, Image} from '@chakra-ui/react'

const Benefit = ({description, title, url, alt, hsaBorder}) => {
    const styles = useStyleConfig('PreFooter')

    return (
        <Stack
            {...styles.benefitBarStack}
            borderRightWidth={{base: '0', md: '0', lg: hsaBorder ? '1px' : '0'}}
            borderRightStyle={{base: 'none', md: 'none', lg: 'solid'}}
            borderRightColor="border.neutral.subtle"
            borderBottomWidth={{
                base: hsaBorder ? '1px' : '0',
                md: hsaBorder ? '1px' : '0',
                lg: '0',
            }}
            borderBottomStyle={{base: 'solid', md: 'solid', lg: 'none'}}
            borderBottomColor="border.neutral.subtle"
            data-testid="benefit-bar-stack"
        >
            <Image src={url} alt={alt} {...styles.benefitBarIcons} />

            <Box {...styles.benefitBarBox} data-testid="benefit-bar-box">
                <Text {...styles.benefitBarHeader} data-testid="benefit-bar-header">
                    {title}
                </Text>
                <Text {...styles.benefitBarText} data-testid="benefit-bar-description">
                    {description}
                </Text>
            </Box>
        </Stack>
    )
}

Benefit.propTypes = {
    description: PropTypes.string,
    title: PropTypes.string,
    url: PropTypes.string,
    alt: PropTypes.string,
    hsaBorder: PropTypes.bool,
}

export default Benefit
